import { render, staticRenderFns } from "./InstitutionStatusTable.vue?vue&type=template&id=e166488c&"
import script from "./InstitutionStatusTable.vue?vue&type=script&lang=js&"
export * from "./InstitutionStatusTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports